import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Online buzz is quite cool",
  "description": "",
  "published": "2009-02-13T00:00:00.000Z",
  "redirect_from": ["/blog/online-buzz-is-quite-cool/swizec/7"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I had my first ever experience in being on the receiving end of some proper online buzz with `}<a parentName="p" {...{
        "href": "http://twitulater.com"
      }}>{`Twitulater`}</a>{`. It started out with `}<a parentName="p" {...{
        "href": "http://blog.go2web20.net/2009/02/twitulater-is-so-great-why-does-it-have.html"
      }}>{`a writeup on go2web2.0`}</a>{`, which I thought was just another blog mentioning Twitulater, two days ago. Hey cool, so I commented. How wrong I was!`}</p>
    <p>{`The blog turned out to be something read by a lot of people, even, it would seem a somewhat important blog since the very next day when I searched twitter for mentions there were a `}<a parentName="p" {...{
        "href": "http://search.twitter.com/search?q=twitulater"
      }}>{`TON`}</a>{`. I think the number stopped at just over 20 and although I realise that's not a lot for many products out there, but it's quite a big deal to me. Best part was how I even got some congrats from people for that writeup. Yay!`}</p>
    <p>{`All of this had a wonderful consequence of website visits being about ten times larger than usual yesterday. Sure, in my case this meant only 100 visits, but for a project that usually gets under ten visits a day, I do think getting a hundred is magnificent. In fact, some microblogging service contacted me and asked if I could integrate their API. Haven't replies yet, but it's looking very likely to happen.`}</p>
    <p>{`Must say I'm quite glad how well Twitulater is turning out as a project and it's almost unbelievable that, with all the other stuff going on in my life, I've come so far in a mere four months. Loving the whole ride!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      